"use strict";

var _Heading, _Text;
import { CopyToClipboard } from '@autoguru/clipboard';
import { AlertIcon } from '@autoguru/icons';
import { ContainedLayout } from '@autoguru/layout';
import { Box, Button, Heading, Icon, Inline, Section, Stack, Text, useTextStyles } from '@autoguru/overdrive';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ErrorFallback = ({
  error,
  resetErrorBoundary,
  hideDetails
}) => /*#__PURE__*/_jsx(ContainedLayout, {
  paddingX: "1",
  width: "narrow",
  children: /*#__PURE__*/_jsx(Section, {
    paddingX: "1",
    width: "small",
    children: /*#__PURE__*/_jsx(Box, {
      "aria-disabled": "true",
      borderWidth: "1",
      borderRadius: "md",
      borderColour: "light",
      paddingY: ['2', '3'],
      paddingX: ['2', '3'],
      children: /*#__PURE__*/_jsxs(Stack, {
        width: "full",
        space: "2",
        alignItems: "center",
        children: [/*#__PURE__*/_jsxs(Inline, {
          space: "5",
          children: [/*#__PURE__*/_jsx(Icon, {
            className: useTextStyles({
              colour: 'danger'
            }),
            size: "large",
            icon: AlertIcon
          }), hideDetails && (_Heading || (_Heading = /*#__PURE__*/_jsx(Heading, {
            as: "h4",
            children: "Something Went Wrong"
          })))]
        }), /*#__PURE__*/_jsxs(Stack, {
          space: "5",
          width: "full",
          alignItems: "stretch",
          children: [/*#__PURE__*/_jsx(Box, {
            width: "full",
            padding: "2",
            backgroundColour: "gray100",
            borderRadius: "md",
            children: hideDetails ? _Text || (_Text = /*#__PURE__*/_jsx(Text, {
              as: "p",
              strong: true,
              size: "3",
              colour: "danger",
              children: "An error has occurred"
            })) : /*#__PURE__*/_jsxs(Stack, {
              space: "2",
              width: "full",
              alignItems: "stretch",
              children: [/*#__PURE__*/_jsx(Text, {
                as: "p",
                strong: true,
                size: "3",
                colour: "danger",
                children: error.message
              }), Array.isArray(error.graphqlErrors) && error.graphqlErrors.map((error, index) =>
              /*#__PURE__*/
              // biome-ignore lint/suspicious/noArrayIndexKey: migration quick fix. To be fixed when code is touched
              _jsxs(Text, {
                as: "p",
                size: "2",
                colour: "warning",
                children: ["\u2022 ", error.message]
              }, index))]
            })
          }), /*#__PURE__*/_jsxs(Inline, {
            space: "3",
            width: "full",
            alignX: "flexEnd",
            children: [/*#__PURE__*/_jsx(Button, {
              minimal: true,
              onClick: resetErrorBoundary,
              size: "small",
              variant: "secondary",
              children: "Try again"
            }), /*#__PURE__*/_jsx(CopyToClipboard, {
              variant: "secondary",
              size: "small",
              minimal: true,
              title: "Copy",
              toolTip: "Copy error details",
              stringProvider: () => JSON.stringify({
                message: error.message,
                graphqlErrors: error.graphqlErrors
              })
            })]
          })]
        })]
      })
    })
  })
});